import { BREAKPOINTS } from 'fitify-ui-onboarding/src/utils/styled'

import {
  isBigResultsPitchCarouselVariant,
  isBigResultsPitchMockupVariant,
  isSocialProofMillionsVariant,
} from 'data/images/utils'
import type { ImagesDefinition } from 'types/images'

export const F01_IMAGES = {
  experience: {
    background: {
      width: 402,
      height: 540,
      srcSet: [
        '/images/f01/memoji/experience.webp',
        '/images/f01/memoji/experience@2x.webp',
      ],
    },
  },
  experiencePitch: {
    pitch: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/f01/memoji/experience_pitch.webp',
        '/images/f01/memoji/experience_pitch@2x.webp',
      ],
    },
  },
  flexible: {
    background: {
      width: 402,
      height: 540,
      srcSet: [
        '/images/f01/memoji/flexible.webp',
        '/images/f01/memoji/flexible@2x.webp',
      ],
    },
  },
  stairsCardio: {
    background: {
      width: 402,
      height: 540,
      srcSet: [
        '/images/f01/memoji/stairs_cardio.webp',
        '/images/f01/memoji/stairs_cardio@2x.webp',
      ],
    },
  },
  howOftenExercise: {
    background: {
      width: 402,
      height: 540,
      srcSet: [
        '/images/f01/memoji/how_often_exercise.webp',
        '/images/f01/memoji/how_often_exercise@2x.webp',
      ],
    },
  },
  howOftenWalks: {
    background: {
      width: 402,
      height: 540,
      srcSet: [
        '/images/f01/memoji/how_often_walks.webp',
        '/images/f01/memoji/how_often_walks@2x.webp',
      ],
    },
  },
  mainGoal: {
    getToned: {
      width: 186,
      height: 140,
      srcSet: [
        '/images/f01/memoji/goal/main_goal_option_get_toned.webp',
        '/images/f01/memoji/goal/main_goal_option_get_toned@2x.webp',
      ],
    },
    improveFitness: {
      width: 186,
      height: 140,
      srcSet: [
        '/images/f01/memoji/goal/main_goal_option_improve_fitness.webp',
        '/images/f01/memoji/goal/main_goal_option_improve_fitness@2x.webp',
      ],
    },
    loseWeight: {
      width: 186,
      height: 140,
      srcSet: [
        '/images/f01/memoji/goal/main_goal_option_lose_weight.webp',
        '/images/f01/memoji/goal/main_goal_option_lose_weight@2x.webp',
      ],
    },
  },
  bodyTypePitch: {
    endomorph: {
      width: 120,
      height: 256,
      srcSet: [
        '/images/f01/memoji/body-type-pitch/body_type_pitch_endomorph.webp',
        '/images/f01/memoji/body-type-pitch/body_type_pitch_endomorph@2x.webp',
      ],
    },
    mesomorph: {
      width: 120,
      height: 256,
      srcSet: [
        '/images/f01/memoji/body-type-pitch/body_type_pitch_mesomorph.webp',
        '/images/f01/memoji/body-type-pitch/body_type_pitch_mesomorph@2x.webp',
      ],
    },
    ectomorph: {
      width: 120,
      height: 256,
      srcSet: [
        '/images/f01/memoji/body-type-pitch/body_type_pitch_ectomorph.webp',
        '/images/f01/memoji/body-type-pitch/body_type_pitch_ectomorph@2x.webp',
      ],
    },
  },
  physicalBuild: {
    extended: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/f01/memoji/physical-build/physical_build_option_extended.webp',
        '/images/f01/memoji/physical-build/physical_build_option_extended@2x.webp',
      ],
    },
    fullfigured: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/f01/memoji/physical-build/physical_build_option_fullfigured.webp',
        '/images/f01/memoji/physical-build/physical_build_option_fullfigured@2x.webp',
      ],
    },
    midsized: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/f01/memoji/physical-build/physical_build_option_midsized.webp',
        '/images/f01/memoji/physical-build/physical_build_option_midsized@2x.webp',
      ],
    },
    slim: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/f01/memoji/physical-build/physical_build_option_slim.webp',
        '/images/f01/memoji/physical-build/physical_build_option_slim@2x.webp',
      ],
    },
  },
  bigResultsPitch: {
    first: {
      width: 272,
      height: 320,
      srcSet: [
        '/images/f01/memoji/big-results-pitch/big_results_pitch_01.webp',
        '/images/f01/memoji/big-results-pitch/big_results_pitch_01@2x.webp',
      ],
      prefetchCondition: isBigResultsPitchCarouselVariant,
    },
    second: {
      width: 272,
      height: 320,
      srcSet: [
        '/images/f01/memoji/big-results-pitch/big_results_pitch_02.webp',
        '/images/f01/memoji/big-results-pitch/big_results_pitch_02@2x.webp',
      ],
      prefetchCondition: isBigResultsPitchCarouselVariant,
    },
    third: {
      width: 272,
      height: 320,
      srcSet: [
        '/images/f01/memoji/big-results-pitch/big_results_pitch_03.webp',
        '/images/f01/memoji/big-results-pitch/big_results_pitch_03@2x.webp',
      ],
      prefetchCondition: isBigResultsPitchCarouselVariant,
    },
    mockup: {
      width: 370,
      height: 300,
      srcSet: [
        '/images/f01/memoji/big-results-pitch/big_results_pitch_mockup_{{locale}}.webp',
        '/images/f01/memoji/big-results-pitch/big_results_pitch_mockup_{{locale}}@2x.webp',
      ],
      prefetchCondition: isBigResultsPitchMockupVariant,
    },
  },
  socialProofMillions: {
    pitch: {
      width: 370,
      height: 364,
      srcSet: [
        '/images/f01/memoji/social_proof_millions.webp',
        '/images/f01/memoji/social_proof_millions@2x.webp',
      ],
      prefetchCondition: isSocialProofMillionsVariant('default'),
    },
    group: {
      width: 370,
      height: 300,
      srcSet: [
        '/images/f01/memoji/social-proof-millions/group.webp',
        '/images/f01/memoji/social-proof-millions/group@2x.webp',
      ],
      prefetchCondition: isSocialProofMillionsVariant('group'),
    },
  },
  struggle: {
    back: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/f01/memoji/struggle/struggle_option_back.webp',
        '/images/f01/memoji/struggle/struggle_option_back@2x.webp',
      ],
    },
    knees: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/f01/memoji/struggle/struggle_option_knees.webp',
        '/images/f01/memoji/struggle/struggle_option_knees@2x.webp',
      ],
    },
    none: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/f01/memoji/struggle/struggle_option_none.webp',
        '/images/f01/memoji/struggle/struggle_option_none@2x.webp',
      ],
    },
  },
  strugglePitch: {
    knees: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/f01/memoji/struggle-pitch/struggle_pitch_knees.webp',
        '/images/f01/memoji/struggle-pitch/struggle_pitch_knees@2x.webp',
      ],
    },
    back: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/f01/memoji/struggle-pitch/struggle_pitch_back.webp',
        '/images/f01/memoji/struggle-pitch/struggle_pitch_back@2x.webp',
      ],
    },
    both: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/f01/memoji/struggle-pitch/struggle_pitch_both.webp',
        '/images/f01/memoji/struggle-pitch/struggle_pitch_both@2x.webp',
      ],
    },
  },
  problemAreas: {
    belly: {
      width: 186,
      height: 86,
      srcSet: [
        '/images/f01/memoji/problem-areas/problem_areas_option_belly.webp',
        '/images/f01/memoji/problem-areas/problem_areas_option_belly@2x.webp',
      ],
    },
    butt: {
      width: 186,
      height: 86,
      srcSet: [
        '/images/f01/memoji/problem-areas/problem_areas_option_butt.webp',
        '/images/f01/memoji/problem-areas/problem_areas_option_butt@2x.webp',
      ],
    },
    chest: {
      width: 186,
      height: 86,
      srcSet: [
        '/images/f01/memoji/problem-areas/problem_areas_option_chest.webp',
        '/images/f01/memoji/problem-areas/problem_areas_option_chest@2x.webp',
      ],
    },
    legs: {
      width: 186,
      height: 86,
      srcSet: [
        '/images/f01/memoji/problem-areas/problem_areas_option_legs.webp',
        '/images/f01/memoji/problem-areas/problem_areas_option_legs@2x.webp',
      ],
    },
    arms: {
      width: 186,
      height: 86,
      srcSet: [
        '/images/f01/memoji/problem-areas/problem_areas_option_arms.webp',
        '/images/f01/memoji/problem-areas/problem_areas_option_arms@2x.webp',
      ],
    },
  },
  problemAreasPitch: {
    mockup: {
      width: 370,
      height: 300,
      srcSet: [
        '/images/f01/memoji/problem-areas-pitch/problem_areas_pitch_mockup_{{locale}}.webp',
        '/images/f01/memoji/problem-areas-pitch/problem_areas_pitch_mockup_{{locale}}@2x.webp',
      ],
    },
  },
  waterIntake: {
    header: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/f01/memoji/water_intake.webp',
        '/images/f01/memoji/water_intake@2x.webp',
      ],
    },
  },
  sleepDuration: {
    header: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/f01/memoji/sleep_duration.webp',
        '/images/f01/memoji/sleep_duration@2x.webp',
      ],
    },
  },
  bodyGoal: {
    thin: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/f01/memoji/body-goal/body_goal_option_thin.webp',
        '/images/f01/memoji/body-goal/body_goal_option_thin@2x.webp',
      ],
    },
    toned: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/f01/memoji/body-goal/body_goal_option_toned.webp',
        '/images/f01/memoji/body-goal/body_goal_option_toned@2x.webp',
      ],
    },
    curvy: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/f01/memoji/body-goal/body_goal_option_curvy.webp',
        '/images/f01/memoji/body-goal/body_goal_option_curvy@2x.webp',
      ],
    },
    average: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/f01/memoji/body-goal/body_goal_option_average.webp',
        '/images/f01/memoji/body-goal/body_goal_option_average@2x.webp',
      ],
    },
  },
  welcomeAgeBuckets: {
    heroBackground: {
      width: 651,
      height: 651,
      srcSet: [
        '/images/f01/memoji/welcome-age-buckets/hero_background.webp',
        '/images/f01/memoji/welcome-age-buckets/hero_background@2x.webp',
      ],
    },
    heroBackgroundDesktop: {
      media: BREAKPOINTS.MD,
      width: 1436,
      height: 651,
      srcSet: [
        '/images/f01/memoji/welcome-age-buckets/hero_background_desktop.webp',
        '/images/f01/memoji/welcome-age-buckets/hero_background_desktop@2x.webp',
      ],
    },
  },
  timeBreakfast: {
    header: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/f01/memoji/time_breakfast.webp',
        '/images/f01/memoji/time_breakfast@2x.webp',
      ],
    },
  },
  timeLunch: {
    header: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/f01/memoji/time_lunch.webp',
        '/images/f01/memoji/time_lunch@2x.webp',
      ],
    },
  },
  timeDinner: {
    header: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/f01/memoji/time_dinner.webp',
        '/images/f01/memoji/time_dinner@2x.webp',
      ],
    },
  },
  wellnessProfile: {
    extended: {
      width: 148,
      height: 273,
      srcSet: [
        '/images/f01/memoji/wellness-profile/wellness_profile_extended.webp',
        '/images/f01/memoji/wellness-profile/wellness_profile_extended@2x.webp',
      ],
    },
    fullFigured: {
      width: 148,
      height: 273,
      srcSet: [
        '/images/f01/memoji/wellness-profile/wellness_profile_fullfigured.webp',
        '/images/f01/memoji/wellness-profile/wellness_profile_fullfigured@2x.webp',
      ],
    },
    midSized: {
      width: 148,
      height: 273,
      srcSet: [
        '/images/f01/memoji/wellness-profile/wellness_profile_midsized.webp',
        '/images/f01/memoji/wellness-profile/wellness_profile_midsized@2x.webp',
      ],
    },
    slim: {
      width: 148,
      height: 273,
      srcSet: [
        '/images/f01/memoji/wellness-profile/wellness_profile_slim.webp',
        '/images/f01/memoji/wellness-profile/wellness_profile_slim@2x.webp',
      ],
    },
  },
  subscription: {
    beforeExtended: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/f01/memoji/subscription/goal-body/paywall_comparison_before_extended.webp',
        '/images/f01/memoji/subscription/goal-body/paywall_comparison_before_extended@2x.webp',
      ],
    },
    beforeFullfigured: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/f01/memoji/subscription/goal-body/paywall_comparison_before_fullfigured.webp',
        '/images/f01/memoji/subscription/goal-body/paywall_comparison_before_fullfigured@2x.webp',
      ],
    },
    beforeMidsized: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/f01/memoji/subscription/goal-body/paywall_comparison_before_midsized.webp',
        '/images/f01/memoji/subscription/goal-body/paywall_comparison_before_midsized@2x.webp',
      ],
    },
    beforeSlim: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/f01/memoji/subscription/goal-body/paywall_comparison_before_slim.webp',
        '/images/f01/memoji/subscription/goal-body/paywall_comparison_before_slim@2x.webp',
      ],
    },
    afterThin: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/f01/memoji/subscription/goal-body/paywall_comparison_after_thin.webp',
        '/images/f01/memoji/subscription/goal-body/paywall_comparison_after_thin@2x.webp',
      ],
    },
    afterToned: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/f01/memoji/subscription/goal-body/paywall_comparison_after_toned.webp',
        '/images/f01/memoji/subscription/goal-body/paywall_comparison_after_toned@2x.webp',
      ],
    },
    afterCurvy: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/f01/memoji/subscription/goal-body/paywall_comparison_after_curvy.webp',
        '/images/f01/memoji/subscription/goal-body/paywall_comparison_after_curvy@2x.webp',
      ],
    },
    afterAverage: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/f01/memoji/subscription/goal-body/paywall_comparison_after_average.webp',
        '/images/f01/memoji/subscription/goal-body/paywall_comparison_after_average@2x.webp',
      ],
    },
  },
  consistencyPitch: {
    pitch: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/f01/memoji/consistency-pitch/consistency_pitch.webp',
        '/images/f01/memoji/consistency-pitch/consistency_pitch@2x.webp',
      ],
    },
  },
} satisfies ImagesDefinition
